module.exports = __webpack_public_path__ + "img/wx.827c9c20.png";